export function discountLimitMessage(
  maximum: number,
  prefix: '%' | 'R$',
  isSurcharge = false,
): string {
  const operation = isSurcharge ? 'ACRÉSCIMO' : 'DESCONTO';
  return prefix === 'R$'
    ? `O ${operation} não pode ser maior que R$ ${maximum} Alterado para o valor permitido!`
    : `O ${operation} não pode ser maior que ${maximum ?? 0}%. Alterado para o valor máximo!`;
}
